module.exports = __webpack_public_path__ + "static/media/CommonWarning.9cc44586.svg";